module.exports = __webpack_public_path__ + "img/corrugatedBox12.8fae1c2f.jpg";